// import { motion } from "framer-motion/dist/framer-motion";

import { DesktopHeader } from "components";
import PaddingX from "layouts/PaddingX";
import useStickyHeaderOffset from "hooks/useStickyHeaderOffset";
import "./reader.css";
import { now } from "moment";
import { AiOutlineCopyrightCircle } from "react-icons/ai";
import Moment from "react-moment";
import { Link } from "react-router-dom";

function QuickLinks({ path, label, width }) {
	return (
		<Link to={path} className="flex flex-col items-center">
			<span>{label}</span>
			{/* <span
				className="border-b-4 border-akgreen pt-1 w-full"
				style={{ width: width ?? 24 }}
			/> */}
		</Link>
	);
}
// text-sm font-thin font-sans text-akgreenest min-h-screen relative bg-white

const Container = ({ children, className = "", footer, skipLink }) => {
	const headerHeight = useStickyHeaderOffset();
	return (
		<div
			style={{ "--site-header-height": `${headerHeight}px` }}
			className={`reader-shell min-h-screen flex flex-col justify-between text-sm font-thin font-sans text-akgreenest relative bg-white  ${className}`}
		>
			{skipLink}
			<div className="flex-1 ">
				<DesktopHeader />
				<div className="reader-content">{children}</div>
			</div>

			{footer !== undefined ? footer : (
				<footer
				className="pt-8 flex flex-col justify-end text-xs xs:text-sm "
				style={{
					paddingBottom: "max(2rem, env(safe-area-inset-bottom))",
				}}
			>
				<PaddingX>
					<div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-center ">
						<QuickLinks path="/terms-and-conditions" label="Terms and conditions" width={80} />
						<QuickLinks path="/privacy-policy" label="Privacy policy" width={50} />
						<QuickLinks path="/support" label="Support" width={30} />
					</div>

					<div className="flex flex-wrap justify-center gap-x-2 gap-y-1 border-gray-200">
						<Link to="/account-deletion-manual">Account deletion</Link>
						<Link to="/downloads">Downloads</Link>
					</div>

					<div className="flex flex-wrap justify-center gap-1 items-center pt-2 font-bold">
						<AiOutlineCopyrightCircle size={20} /> <Moment format="y">{now()}</Moment> Akello
						library
					</div>
				</PaddingX>
				</footer>
			)}
		</div>
	);
};

export default Container;
